import { isLibrarySaveEnabled } from "../../api/library";
import { buildLibraryDocumentForTool } from "./libraryDocumentRegistry";
import { executeSaveToLibraryWorkflow } from "./saveToLibraryWorkflow";

const GENERATION_TO_LIBRARY_TOOL_ID = {
  "quick-sheets": "lesson-flow",
};

function resolveLibraryToolId(toolId) {
  return GENERATION_TO_LIBRARY_TOOL_ID[toolId] ?? toolId;
}

export async function runHeadlessLibrarySave({ toolId, result }) {
  if (!isLibrarySaveEnabled()) {
    return null;
  }

  const built = buildLibraryDocumentForTool(toolId, result);
  if (!built) {
    return null;
  }

  try {
    return await executeSaveToLibraryWorkflow({
      document: built.document,
      contentSnapshot: result,
      context: {
        toolId: resolveLibraryToolId(toolId),
        contentKey: built.contentKey,
        title: built.title,
      },
    });
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[headless-library-save]", error);
    }
    return null;
  }
}
